import { apiClient } from '@/api/client'
import type {
  BulkOverrideResult,
  FleetOverview,
  FleetSeverity,
  NotificationChannelsResponse,
  SaveSiteSeverityRulesResult,
  SiteSeverityRulesResponse,
  UnsubscribeSeverityResult,
} from './types'

const BASE = '/portal/settings/alarms/subscriptions/fleet'

export async function fetchFleetOverview(): Promise<FleetOverview> {
  const { data } = await apiClient.get<FleetOverview>(`${BASE}/summary`)
  return data
}

export async function applyFleetSeverityDefault(severityId: number, isSubscribed: boolean): Promise<FleetSeverity> {
  const { data } = await apiClient.post<FleetSeverity>(`${BASE}/severity/${severityId}`, {
    is_subscribed: isSubscribed,
  })
  return data
}

/** Remove the given systems from a severity, or every system (which also turns the fleet default off). */
export async function unsubscribeFleetSeverity(
  severityId: number,
  target: { controllerIds: string[] } | { all: true },
): Promise<UnsubscribeSeverityResult> {
  const body = 'all' in target ? { all: true } : { controller_ids: target.controllerIds }
  const { data } = await apiClient.post<UnsubscribeSeverityResult>(`${BASE}/severity/${severityId}/unsubscribe`, body)
  return data
}

export async function applyFleetBulkOverride(
  controllerIds: string[],
  overrides: Record<number, boolean>,
): Promise<BulkOverrideResult> {
  const { data } = await apiClient.post<BulkOverrideResult>(`${BASE}/bulk`, {
    controller_ids: controllerIds,
    overrides,
  })
  return data
}

export async function fetchSiteSeverityRules(): Promise<SiteSeverityRulesResponse> {
  const { data } = await apiClient.get<SiteSeverityRulesResponse>(`${BASE}/site-severity`)
  return data
}

/** true subscribes the sites to every alarm of the severity, null removes the rule. */
export async function saveSiteSeverityRules(
  controllerIds: string[],
  severities: Record<number, boolean | null>,
): Promise<SaveSiteSeverityRulesResult> {
  const { data } = await apiClient.post<SaveSiteSeverityRulesResult>(`${BASE}/site-severity`, {
    controller_ids: controllerIds,
    severities,
  })
  return data
}

const CHANNELS_URL = '/portal/settings/alarms/subscriptions/channels'

export async function fetchNotificationChannels(): Promise<NotificationChannelsResponse> {
  const { data } = await apiClient.get<NotificationChannelsResponse>(CHANNELS_URL)
  return data
}

export async function saveNotificationChannels(
  channels: Record<string, boolean>,
): Promise<NotificationChannelsResponse> {
  const { data } = await apiClient.post<NotificationChannelsResponse>(CHANNELS_URL, { channels })
  return data
}
